import curry from 'lodash/curry';

import IThemeInterface from '../../Theme/common';

// tslint:disable: strict-type-predicates
export const normalizeColor = curry((
  theme: IThemeInterface,
  color: string | undefined
): string => {
  /* Returns the specific color that should be used according to the theme. */
  if (color === undefined) { return ''; }

  const colorSpec =
    theme.global && theme.global.colors[color] !== undefined
      ? theme.global.colors[color]
      : color;

  let result = colorSpec;
  // allow one level of indirection in color names
  if (result && theme.global && theme.global.colors[result] !== undefined) {
    result = normalizeColor(theme, result);
  }

  return result;
});
